import { useCallback, useEffect } from 'react';
import { useAuth } from '../context';
import { useRealtimeConnected, useRealtimeTopic } from './useRealtimeTopic';
import { setRealtimeAuthToken, ensureRealtimeConnected } from '../utils/realtimeSocket';

export function useBalancePolling(intervalMs = 5000) {
  const { token, user, refreshUser } = useAuth();
  const userId = user?.id;
  const wsConnected = useRealtimeConnected();

  useEffect(() => {
    setRealtimeAuthToken(token || null);
    if (token) ensureRealtimeConnected();
  }, [token]);

  const onBalance = useCallback((data) => {
    if (!data) return;
    refreshUser(data).catch(() => {});
  }, [refreshUser]);

  useRealtimeTopic('balance', onBalance, Boolean(token && userId));

  useEffect(() => {
    if (!token || !userId || !intervalMs) return undefined;

    let alive = true;
    const tick = () => {
      if (!alive) return;
      refreshUser().catch(() => {});
    };

    const pollMs = wsConnected ? Math.max(intervalMs * 8, 40000) : intervalMs;
    const id = window.setInterval(tick, pollMs);
    return () => {
      alive = false;
      window.clearInterval(id);
    };
  }, [token, userId, refreshUser, intervalMs, wsConnected]);
}
